import { render } from "./BagOfWordsPrintout.vue?vue&type=template&id=0caee446"
import script from "./BagOfWordsPrintout.vue?vue&type=script&lang=js"
export * from "./BagOfWordsPrintout.vue?vue&type=script&lang=js"

import "./BagOfWordsPrintout.vue?vue&type=style&index=0&id=0caee446&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__